export const devStatsReportSelector = state => (state.administration.reports.devStatsReport.data.pagedCollection);
export const devStatsReportTotalPages = state => (state.administration.reports.devStatsReport.data.totalPages);
